import api from './api';

/**
 * insightsSettingsService — frontend client for /api/v1/settings/insights.
 *
 * Two endpoints:
 *   get()         — returns { ai_insights_enabled, portfolio_risk_threshold_pct,
 *                            rules_enabled, rules_catalog }
 *   update(body)  — PATCH any subset of the three writable fields.
 *                  Returns the same shape, plus cascade_results when
 *                  the change triggered cascade-expirations.
 */
const insightsSettingsService = {
  async get() {
    const response = await api.get('/settings/insights');
    return response.data?.data || null;
  },

  /**
   * @param {object} updates
   *   ai_insights_enabled?:           boolean
   *   portfolio_risk_threshold_pct?:  number (5..50)
   *   rules_enabled?:                 { [rule_key]: boolean }
   */
  async update(updates) {
    const response = await api.patch('/settings/insights', updates || {});
    return response.data?.data || null;
  }
};

export default insightsSettingsService;
